export function getUrlOfCurrencyLogo ({ tokenAddress, height, width, extend = 1, logo = true }) {
	return `${process.env.VUE_APP_MEDIAHUB_BASE_URL}/v1/media/currency:${tokenAddress}/${logo ? 'logo' : 'thumbnail'}?sizeParams=${height * extend}x${width * extend}`;
}
